import {
  UpdateBusinessUnitWorkTypesRequest,
  UpdateBusinessUnitWorkTypesResponse,
} from "./types";
import axiosInstance from "../axiosInstance";

export const updateBusinessUnitWorkTypes = async (
  companyUuid: string,
  request: UpdateBusinessUnitWorkTypesRequest,
): Promise<UpdateBusinessUnitWorkTypesResponse> => {
  const response =
    await axiosInstance.patch<UpdateBusinessUnitWorkTypesResponse>(
      `/api/private/companies/${companyUuid}/service-titan/business-units/work-types`,
      request,
    );
  return response.data;
};
